"use client"
import React, { useState, useEffect } from "react";
import { Modal, Tab } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";

import MapPointForm from "@/components/maps/MapPointForm";

import useApi from "@/components/api/useApi";
import InlineSignupForm from "@/components/login/InlineSignupForm";
import "@/components/maps/MapPointFormModal.css";
import LoadingAnimation from "@/components/shared/LoadingAnimation";

const MapPointFormModal = ({
  name,
  authentication,
  mapId,
  pointId,
  point,
  onPointSubmitted,
  onPointAdded,
  onPointEdited,
  layers,
  defaultLayer,
  onCancel,
  modalTitle,
  submission
}) => {
  const api = useApi();
  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });

  const [modalFooter, setModalFooter] = useState(null);
  const [selectedTab, setSelectedTab] = useState("edit");

  const [filesToUpload, setFilesToUpload] = useState(null);
  const [deferredPayload, setDeferredPayload] = useState(null);

  useEffect(() => {
    setModalFooter(document.getElementById("map-point-form-modal-footer"));
  }, []);

  const deferredSave = (values, files) => {
    setDeferredPayload(values);
    setFilesToUpload(files);
    setSelectedTab("auth");
  };

  const userRegistered = ({ resourceName, passwordToken, submissionToken }) => {
    if (resourceName) {
      onSubmitDeferredSave(
        resourceName,
        deferredPayload,
        filesToUpload,
        submissionToken
      );
    }
  };

  const onSubmitDeferredSave = (
    newResourceName,
    values,
    files,
    submissionToken
  ) => {
    // make the call to upload the files given the name
    let uploadFiles = files.map((theFile, index) => {
      return api.uploadFile(
        newResourceName,
        theFile.file,
        theFile.exif,
        submissionToken
      );
    });
    Promise.all(uploadFiles)
      .then(uploadedFiles => {
        uploadedFiles.forEach(function(asset, index) {
          if (asset.owner) {
            asset.owner = asset.owner.resourceName;
          }
        });
        values["assets"] = uploadedFiles;
        values["external"] = true;
        values["ownerResourceName"] = newResourceName;

        var apiMethod = api.submitProfileMapPoint(
          name,
          mapId,
          values,
          submissionToken
        );

        apiMethod
          .then(success => {
            onPointSubmitted();
          })
          .catch(error => {
            // TODO report an error
            console.error(error);
          });
      })
      .catch(err => {
        // TODO report an error
        console.error(err);
      });
  };

  return (
    <Modal
      className="map-point-form-modal"
      show={true}
      size="lg"
      centered
      onHide={() => onCancel()}
      scrollable={true}
      fullscreen={isSm}
    >
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tab.Container activeKey={selectedTab} mountOnEnter={true}>
          <Tab.Content>
            <Tab.Pane eventKey="edit">
              <MapPointForm
                name={name}
                mapId={mapId}
                pointId={pointId}
                point={point}
                defaultLayer={defaultLayer}
                layers={layers}
                onPointAdded={onPointAdded}
                onPointEdited={onPointEdited}
                onPointSubmitted={onPointSubmitted}
                onCancel={onCancel}
                authentication={authentication}
                submission={submission}
                modalFooter={modalFooter}
                onDeferredSubmission={deferredSave}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="auth">
              <InlineSignupForm
                name={name}
                showHeading={true}
                heading="Please create an account."
                text="In order to submit your contribution, please provide the following information to create your account. We'll send you an activation link to your email address."
                type="AMBASSADOR"
                onRegistrationComplete={userRegistered}
                overrideApproveComponent={<LoadingAnimation />}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Modal.Body>
      <Modal.Footer
        style={{ display: selectedTab === "edit" ? "flex" : "none" }}
      >
        <div id="map-point-form-modal-footer"></div>
      </Modal.Footer>
    </Modal>
  );
};
export default MapPointFormModal;
